import React, { useReducer } from "react";
import Radio from "antd/es/radio";
import Form from "antd/es/form";
import "antd/es/form/style";
import Skeleton from "antd/es/skeleton";
import "antd/es/skeleton/style";
import { Modal } from "../../atoms/modals/antd-modals";
import { Button } from "../../atoms/buttons/buttons";
import openNotification from "../../../utilities/openNotification";
import { useQueryClient } from "react-query";
import appointmentsAPI from "../../../utilities/api/appointment";
import shiftsAPI from "../../../utilities/api/shift";
import DataStateHandler from "../../../utilities/DataStateHandler";
import useGetAppointmentsDetails from "../../../utilities/hooks/useGetAppointmentDetails";
import useGetCancellationReasons from "../../../utilities/hooks/useGetCancellationReasons";
import styles from "./style.module.scss";
import { StyledInput } from "../../atoms";
import TextArea from "antd/lib/input/TextArea";
import { pick } from "lodash";

function ReasonsToCancelAppointmentModal({
  isOpen,
  onExit,
  selectedReasonForCancel,
  setSelectedReasonForCancel,
  loading,
  setLoading,
  appointmentId,
  businessId,
  setOtherReasonExplanation,
  otherReasonExplanation,
  slotId,
  handleSubmit,
  copyType,
  setAdditionalDetailsInParent,
}) {
  const [additionalDetails, setAdditionalDetails] = React.useState("");
  const {
    data: selectedAppointment,
    isLoading,
    refetch,
    should_show_warning,
    able_to_adjust
  } = useGetAppointmentsDetails({
    appointmentId,
  });

  const {
    data: cancellationReasons,
    isLoading: isCancellationReasonsLoading,
    isError: isCancellationError,
    error: cancellationError,
  } = useGetCancellationReasons(businessId);

  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  // const [cancelAppointment, setCancelAppointment] = useReducer(
  //   (prev, next) => ({
  //     ...prev,
  //     ...next,
  //   }),
  //   {
  //     isModalOpen: false,
  //     isModalloading: false,
  //     isFeeModalOpen: false,
  //     isFeeModalLoading: false,
  //     isReasonsModalOpen: false,
  //     isReasonsModalLoading: false,
  //   }
  // );

  const handleCancelAppointment = () => {
    let data = {
      id: selectedAppointment?.appointment_number,
      businessId: selectedAppointment?.business_id,
      locationId: selectedAppointment?.location_id,
      client_cancellation_reason_id: selectedReasonForCancel === "other" ? "" : selectedReasonForCancel.id,
      quoted_fee: selectedAppointment?.cancellation_fee,
      fee_reason: selectedAppointment?.cancel_fee_reason,
      cancellation_reason_index: selectedReasonForCancel.index,
      custom_cancellation_reason: selectedReasonForCancel === "other" ? otherReasonExplanation : null,
      additional_details: additionalDetails,
    };
    // setCancelAppointment({ isReasonsModalLoading: true });
    if (slotId) {
      handleSubmit(pick(data, ["client_cancellation_reason_id", "custom_cancellation_reason", "additional_details", "cancellation_reason_index"]));
    } else onCancelAppointment(data);
  };

  const onCancelAppointment = async (data) => {
    setLoading(true);

    try {
      let response;
      if (selectedAppointment.is_staffing || selectedAppointment.is_employee_wellness) {
        response = await shiftsAPI.deleteShift(data);
      } else response = await appointmentsAPI.deleteAppointment(data);
      setLoading(false);
      // setCancelAppointment({
      //   isModalLoading: false,
      //   isModalOpen: false,
      //   isFeeModalLoading: false,
      //   isFeeModalOpen: false,
      //   isReasonsModalOpen: false,
      // });
      openNotification("Cancel Appointment", response.data.message, "success");
      refetch();
      queryClient.refetchQueries("getWaivableFees");
      queryClient.refetchQueries("appointments");
      queryClient.refetchQueries("shifts");
      queryClient.refetchQueries("businessAppointments");
      queryClient.refetchQueries("allBusinessesAppointments");
      onExit();
    } catch (err) {
      setLoading(false);
      openNotification("Error", err.response.data.message, "error");
    }
  };

  return (
    <>
      <Modal
        wrapClassName={styles["modal-container"]}
        title={
          !isCancellationReasonsLoading ?
            slotId ? `Please share your reason for removing this ${copyType}.` : `Please share your reason for cancelling this shift.` : ""
        }
        visible={isOpen}
        footer={null}
        onCancel={onExit}
        centered
      >
        <DataStateHandler
          style={{ height: "40vh" }}
          isLoading={isLoading || isCancellationReasonsLoading}
          loadingComponent={<Skeleton active paragraph={{ rows: 8 }} />}
          isError={isCancellationError}
          error={cancellationError}
          data={cancellationReasons?.length}
        >
          {cancellationReasons && (
            <div className="view-modal-body">
              <Form
                form={form}
                name="reasons"
                onFinish={() => {
                  handleCancelAppointment();
                }}
              >
                <Form.Item
                  name="reason"
                  rules={[
                    {
                      required: true,
                      message: "Please select a reason",
                    },
                  ]}
                >
                  <Radio.Group>
                    <div className="ant-radio-btn-vertical">
                      {cancellationReasons.map((cancellationReason, index) => (
                        <Radio
                          key={cancellationReason.id}
                          disabled={false}
                          value={cancellationReason.id}
                          onChange={(e) => {
                            setSelectedReasonForCancel({
                              id: e.target.value,
                              index,
                            })
                            setOtherReasonExplanation("");
                          }}
                        >
                          {cancellationReason.reason}
                        </Radio>
                      ))}
                    </div>
                    <div className="ant-radio-btn_input">
                      <Radio
                        key={"other"}
                        disabled={false}
                        value={"other"}
                        onChange={(e) => setSelectedReasonForCancel(e.target.value)}
                      >
                        Other:
                      </Radio>

                      <StyledInput
                        placeholder="Enter other reason"
                        defaultValue={otherReasonExplanation}
                        onChange={(e) => setOtherReasonExplanation(e.target.value)}
                        disabled={selectedReasonForCancel !== "other"}
                        required={selectedReasonForCancel === "other"}
                      />
                    </div>
                  </Radio.Group>
                </Form.Item>
                <div style={{
                  fontSize: "14px",
                  lineHeight: "20px",
                  fontWeight: "400",
                  marginBottom: "14px",
                }}>Additional Details*</div>
                <Form.Item
                  name="additional-details"
                  rules={[
                    {
                      required: true,
                      message: "Please add additional details",
                    },
                  ]}>
                  <TextArea
                    value={additionalDetails}
                    onChange={(e) => {
                      let temp = e.target.value;
                      setAdditionalDetails(temp);
                      if (setAdditionalDetailsInParent) {
                        setAdditionalDetailsInParent(temp);
                      }
                    }}
                    rows={4}
                    style={{ backgroundColor: "#FFFFFF", borderRadius: "4px" }}
                    maxLength={255}
                    showCount>
                  </TextArea>
                </Form.Item>
                <footer>
                  <Button
                    key="cancel"
                    size="small"
                    onClick={onExit}
                    type="light"
                  >
                    Close without saving
                  </Button>

                  <Button
                    style={{ margin: 0 }}
                    key="submit"
                    size="small"
                    type="danger"
                    htmlType="submit"
                    loading={loading}
                  >
                    Submit and {slotId ? `remove ${copyType}` : "cancel shift"}
                  </Button>
                </footer>
              </Form>
            </div>
          )}
        </DataStateHandler>
      </Modal>
    </>
  );
}

export default ReasonsToCancelAppointmentModal;
